var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5278_19214)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.422 33.3511C16.3886 33.3511 11.4972 28.4597 11.4972 22.4264C11.4972 16.3931 16.3886 11.4958 22.422 11.4958V2.55469C11.4502 2.55469 2.55615 11.4487 2.55615 22.4205C2.55615 33.3923 11.4502 42.2863 22.422 42.2863C33.3938 42.2863 42.2878 33.3923 42.2878 22.4205H33.3467C33.3467 28.4538 28.4553 33.3452 22.422 33.3452V33.3511Z",
    fill: "#2354E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4219 22.4208H33.3525V11.4961H22.4219V22.4208Z",
    fill: "#17E6A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5278_19214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.35,
    height: 43.35,
    fill: "white",
    transform: "translate(0.75 0.75)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGate);
export default __webpack_public_path__ + "static/media/gate.7b37879ccd6a9642e43858964f3bd842.svg";
export { ForwardRef as ReactComponent };